<!--
 * @Author: tfq
 * @Date: 2025-09-23 10:38:22
 * @LastEditTime: 2026-01-21 14:31:50
 * @Description: 
-->
<template>
  <div class="baseInfo">
    <div class="default">
      <!-- <img :src="productImg.defaultImageView" alt="" /> -->
      <van-swipe class="my-swipe" v-if="carouselImages.length || productImg.videoUrlView" style="height: 750px;"
        :autoplay="30000" @touchstart.native.stop @touchmove.native.stop @touchend.native.stop @change="onChange">
        <van-swipe-item v-if="productImg.videoUrlView" :key="productImg.videoUrlView">
          <MyVideo :url="productImg.videoUrlView" :poster="[...carouselImages, ...goodsPicsList, ...swipeList][0]" />
        </van-swipe-item>
        <van-swipe-item v-for="item in carouselImages" :key="item">
          <img :src="item" alt="" style="width: 100%; height: 100%" />
        </van-swipe-item>
      </van-swipe>
      <van-swipe class="my-swipe" v-else style="height: 750px;" :autoplay="30000" @touchstart.native.stop
        @touchmove.native.stop @touchend.native.stop @change="onChange">
        <van-swipe-item v-for="item in swipeList" :key="item">
          <img :src="item" alt="" style="width: 100%; height: 100%" />
        </van-swipe-item>
      </van-swipe>
      <div class="baseInfoDetail">
        <div class="title">
          {{ productImg.name }}
        </div>
        <div class="desc">
          <div><span>材质</span>{{ productImg.metalName }}</div>
          <div v-if="skuSn"><span>规格</span>{{ skuInfo ? skuInfo.name : '' }}({{ skuSn }})</div>
          <div v-else-if="barCode"><span>监管码</span>{{ barCode }}</div>
          <div v-if="thirdUniqueCode"><span>金条编码</span>{{ thirdUniqueCode }}</div>
          <div><span>净金重</span>{{ productImg.weight }}g</div>
        </div>
      </div>
    </div>

    <div class="default mt24" v-if="productImg.detailVideoUrlView || goodsPicsList.length">
      <TitleModel title="详情介绍" />
      <div class="baseInfoPic">
        <!-- 产品要求把展示视频和展示图放到顶部轮播位置 -->
        <div class="picDetail">
          <MyVideo :url="productImg.detailVideoUrlView" :poster="[...goodsPicsList, ...carouselImages, ...swipeList][0]"
            type="handPlay" />
          <img v-for="(item, index) in goodsPicsList" :key="item" :src="item" alt=""
            @click="preImg(goodsPicsList, index)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import column from "@/components/column";
// import myTable from "@/components/table";
import MyVideo from "@/components/video";
import TitleModel from "../TitleModel.vue";
import { ImagePreview } from "vant";
export default {
  props: {
    basicInfoData: {
      type: Object,
      default: () => { },
    },
    productImg: {
      type: Object,
      default: () => { },
    },
    productAllInfo: {
      type: Object,
      default: () => { },
    },
    barCode: {
      type: String,
      default: () => "",
    },
    skuSn: {
      type: String,
      default: () => "",
    },
    thirdUniqueCode: {
      type: String,
    },
  },

  components: { MyVideo, TitleModel },

  data() {
    return {
      maxHeight: 200,
    };
  },
  computed: {
    swipeList() {
      const { defaultImageView, imgLeftView, imgDownView, imgRightView } = this.productImg;
      return [defaultImageView, imgLeftView, imgDownView, imgRightView].filter(i => i)
    },
    carouselImages() {
      return (this.productAllInfo.carouselImages || []).map(i => i.imgUrlView).filter(i => i)
    },
    goodsPicsList() {
      return (this.productAllInfo.goodsPicsList || []).map(i => i.imgUrlView).filter(i => i)
    },
    skuInfo() {
      const wmsProductSpecVOList = this.productAllInfo.wmsProductSpecVOList || []
      if (this.skuSn) {
        return wmsProductSpecVOList.find(i => i.sn === this.skuSn) || null
      }
      return null
    },
  },
  created() {
    console.log(this.productImg, "productImg");
  },
  mounted() { },

  methods: {

    preImg(imgUrl, index) {
      ImagePreview({
        images: imgUrl,
        startPosition: index || 0,
      });
    },
    onChange(index) {
      console.log('当前滑动到第几个轮播图', index);
    },
    getImgInfo(e) {
      const box = this.$refs.refPic;
      const boxWidth = box.clientWidth;
      let height = (e.target.naturalHeight * boxWidth) / e.target.naturalWidth;
      console.log('height', height);
      this.maxHeight = Math.max(this.maxHeight, height);
    },
  },
};
</script>

<style lang="less" scoped>
.baseInfo {
  width: 100%;

  .mt24 {
    margin-top: 24px;
  }

  .default {
    width: 100%;
    background: #ffffff;
    box-sizing: border-box;
    opacity: 1;

    .baseInfoDetail {
      padding: 24px;

      .title {
        width: 100%;
        color: #333333;
        font-size: 28px;
        line-height: 39px;
        font-weight: bold;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .desc {
        display: flex;
        flex-direction: column;
        font-size: 26px;
        line-height: 37px;
        color: #333;

        div {
          margin-top: 16px;

          span {
            color: #666;
            margin-right: 8px;
          }
        }
      }

    }

    .my-swipe {
      width: 100%;
      touch-action: pan-y !important;
      -webkit-user-select: none;
      user-select: none;
      -webkit-touch-callout: none;
      -webkit-user-drag: none;
    }
  }

  .productPic {
    display: block;
    width: 439px;
    height: 45px;
    margin: 24px auto;
  }

  .baseInfoPic {
    background: #ffffff;

    img {
      width: 100%;
    }
  }
}

::v-deep .van-swipe__track {
  width: 100% !important;

  .van-swipe-item {
    width: 100% !important;
  }
}

::v-deep .van-swipe__indicator--active {
  width: 24px !important;
  height: 8px;
  background: #FFFFFF !important;
  box-shadow: 0px 1px 6px 1px rgba(0, 0, 0, 0.25);
  border-radius: 8px 8px 8px 8px;
}

::v-deep .van-swipe__indicator {
  width: 8px;
  height: 8px;
  background: #999999;
  border-radius: 8px 8px 8px 8px;
  opacity: 0.55;
}

.my-swipe .van-swipe-item {
  height: 100%;
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;

  img {
    object-fit: contain;
  }
}
</style>
